import { Holiday } from "../../../../../../services/npi-holiday-service";

export const WEEKDAY_LABELS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export const MONTH_LABELS = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export interface CalendarCell {
    day: number | null;
    dateKey: string | null;
    isWeekend: boolean;
    holidays: Holiday[];
}

export const buildMonthGrid = (year: number, month: number, holidaysByDate: Map<string, Holiday[]>): CalendarCell[][] => {
    const firstOfMonth = new Date(year, month, 1);
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const mondayIndexOfFirstDay = (firstOfMonth.getDay() + 6) % 7;

    const cells: CalendarCell[] = [];

    for (let i = 0; i < mondayIndexOfFirstDay; i++) {
        cells.push({ day: null, dateKey: null, isWeekend: false, holidays: [] });
    }

    for (let day = 1; day <= daysInMonth; day++) {
        const dateKey = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        const weekday = new Date(year, month, day).getDay();

        cells.push({
            day,
            dateKey,
            isWeekend: weekday === 0 || weekday === 6,
            holidays: holidaysByDate.get(dateKey) ?? [],
        });
    }

    const weeks: CalendarCell[][] = [];
    for (let i = 0; i < cells.length; i += 7) {
        weeks.push(cells.slice(i, i + 7));
    }
    const lastWeek = weeks[weeks.length - 1];
    while (lastWeek.length < 7) {
        lastWeek.push({ day: null, dateKey: null, isWeekend: false, holidays: [] });
    }

    return weeks;
};

export const groupHolidaysByDate = (holidays: Holiday[]): Map<string, Holiday[]> => {
    const map = new Map<string, Holiday[]>();
    holidays.forEach((holiday) => {
        const list = map.get(holiday.date) ?? [];
        list.push(holiday);
        map.set(holiday.date, list);
    });
    return map;
};